import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { ElevatorBusiness } from "@/domains/estate/components/elevator/components/business/ElevatorBusiness/ElevatorBusiness";
import { ElevatorEconomy } from "@/domains/estate/components/elevator/components/economy/ElevatorEconomy";
import { ElevatorStandard } from "@/domains/estate/components/elevator/components/standard/ElevatorStandard";

export type ElevatorControlPanelProps = {
  level: EstateComplexLevel;
  targetFloor: number;
  currentFloor: number;
  floors: number[];
  onTargetFloorChange: (floor: number) => void;
  size: "sm" | "md" | "lg";
};

export function ElevatorControlPanel({
  level,
  targetFloor,
  currentFloor,
  floors,
  onTargetFloorChange,
  size = "sm",
}: ElevatorControlPanelProps) {
  return (
    <>
      {level === EstateComplexLevel.Economy && (
        <ElevatorEconomy
          floors={floors}
          targetFloor={targetFloor}
          currentFloor={currentFloor}
          onTargetFloorChange={onTargetFloorChange}
          size={size}
        />
      )}

      {level === EstateComplexLevel.Standard && (
        <ElevatorStandard
          floors={floors}
          targetFloor={targetFloor}
          currentFloor={currentFloor}
          onTargetFloorChange={onTargetFloorChange}
          level={level}
          size={size}
        />
      )}

      {level === EstateComplexLevel.Business && (
        <ElevatorBusiness
          floors={floors}
          targetFloor={targetFloor}
          currentFloor={currentFloor}
          onTargetFloorChange={onTargetFloorChange}
          size={size}
        />
      )}
    </>
  );
}
